let baseUrl = process.env.VUE_APP_BASEURL
let presenterUrl = process.env.VUE_APP_PRESENTERURL
let baseEnv = process.env.VUE_APP_BASEENV
let awsUrl = process.env.VUE_APP_AWSRURL
const mceEditorKey = process.env.VUE_APP_MCE_EDITOR

export default {
  baseUrl: baseUrl,
  presenterUrl: presenterUrl,
  baseEnv: baseEnv,
  awsUrl: awsUrl,
  mceEditorKey,
  wpWebhook: baseEnv === 'production'
    ? 'https://ahaslides.com/wpwebhook'
    : 'https://dev.ahaslide.com/wpwebhook',
  publicTemplateUrl: baseEnv === 'production'
    ? 'https://ahaslides.com/templates'
    : 'https://dev.ahaslide.com/templates',
  api: {
    googleCallback: `${baseUrl}/api/auth/google/callback-internal/`,
    account: `${baseUrl}/api/users/account/`,
    createStaff: `${baseUrl}/api/users/add-user/`,
    syncEmail: `${baseUrl}/api/users/sync-email/`,
    getListUsers: `${baseUrl}/api/users/get-users/`,
    getProfile: `${baseUrl}/api/users/get-profile/`,
    getUser: `${baseUrl}/api/users/get-user/`,
    updateUser: `${baseUrl}/api/users/`,
    getTokenPresenter: `${baseUrl}/api/users/get-presenter/`,
    sortPresentation: `${baseUrl}/api/presentation/sort/`,
    createOneTime: `${baseUrl}/api/pricing/create-onetime/`,
    stopOneTime: `${baseUrl}/api/pricing/stop-onetime/`,
    uploadFavicon: `${baseUrl}/api/upload/file-favicon/`,
    invoice: `${baseUrl}/api/invoice/`,
    userHistory: `${baseUrl}/api/users/history/`,
    userInvitation: `${baseUrl}/api/users/invitation/`,
    planList: `${baseUrl}/api/plan/`,
    accountConfig: `${baseUrl}/api/users/account-config/`,
    getListAccount: `${baseUrl}/api/accounts/`,
    getPrentations: `${baseUrl}/api/presentation/list/infinity-scroll/`,
    getDeletedPresentations: `${baseUrl}/api/presentation/list/deleted`,
    recoverPresentation: `${baseUrl}/api/presentation-recoveries/`,
    importElCmsPresentation: `${baseUrl}/api/presentation-crawl/el-cms/`,
    getUserCrawler: `${baseUrl}/api/presentation-crawl/users/`,
    importWWTBAMPresentation: `${baseUrl}/api/presentation-crawl/wwtbam/`,
    importDataPresentation: `${baseUrl}/api/presentation-crawl/import/`,

    // sync operations
    syncWebflowPages: `${baseUrl}/api/sync-webflow`,

    // templates
    adminGetTemplates: `${baseUrl}/api/presentation/admin/templates`,
    adminGetPresentationDetail: `${baseUrl}/api/presentation/admin/presentation/`,
    adminPatchPresentationDetail: `${baseUrl}/api/presentation/admin/presentation-patch/`,
    adminUpdatePresentation: `${baseUrl}/api/presentation/admin/presentation-update/`,
    publishPresentation: `${baseUrl}/api/presentation/admin/public-presentations/`,

    //templates categories
    getPresentationCategories: `${baseUrl}/api/presentation/categories`,
    getPresentationCategoryDetail: `${baseUrl}/api/presentation/categories`,
    createPresentationCategories: `${baseUrl}/api/presentation/categories`,
    updatePresentationCategories: `${baseUrl}/api/presentation/categories`,
    deletePresentationCategories: `${baseUrl}/api/presentation/categories`,

    //templates communities
    adminGetTemplateCommunities: `${baseUrl}/api/admin/template-communities`,
    adminGetTemplateCommunitiesDetail: `${baseUrl}/api/admin/template-communities`,
    getTemplateByUser: `${baseUrl}/api/community/public-by-user/`,
    unpublishTemplateByUser: `${baseUrl}/api/community/unpublic-presentations/`,
    uploadImage: `${baseUrl}/api/upload/image/`,
    createNotification: `${baseUrl}/api/notifications/`,
    getAllNotifications: `${baseUrl}/api/notifications/all/`,
    updateNotification: `${baseUrl}/api/notifications/update/`,

    //roles
    getAccountRoles: `${baseUrl}/api/roles/`,

    //presentation themes
    getThemes: `${baseUrl}/api/admin/presentation-themes/`,
    updatePresentationThemes: (id) => `${baseUrl}/api/admin/presentation-themes/${id}/`,

    //account managers
    accountManager: `${baseUrl}/api/admin/account-managers`,
    getAdminUsers: `${baseUrl}/api/users/admin`,
  },
  roles: ["master", "admin", "presenter", "audience"],
  stripeSources: ['singapore', 'australia'],
}
